module.exports = __webpack_public_path__ + "static/aws-2fe16844930e4ab6c6988ca8a5a4c594.png";